<template>
  <el-form 
    ref="form"
    label-width="60%"
    label-position="left"
    :model="form"
    :disabled="disabled"
    size="medium"
  >
    <el-form-item label="高血压" >
      <el-radio-group v-model="form.highBloodPressure" @change="form.highBloodPressureYear = ''" 
        :fill="form.highBloodPressure==''||form.highBloodPressure=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否">否</el-radio-button>
        <el-radio-button label="是">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="高血压史（单位：年）">
      <el-input
        placeholder="高血压史（单位：年）"
        v-model="form.highBloodPressureYear"
        :disabled="form.highBloodPressure == '否'"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="糖尿病">
      <el-radio-group v-model="form.diabetes"
        :fill="form.diabetes==''||form.diabetes=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="糖尿病史（单位：年）">
      <el-input
        placeholder="糖尿病史（单位：年）"
        v-model="form.diabetesYear"
        :disabled="form.diabetes == '否'"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="冠心病或支架植入史">
      <el-radio-group v-model="form.coronaryHeartDisease"
        :fill="form.coronaryHeartDisease==''||form.coronaryHeartDisease=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="冠心病或支架植入史（单位：年）">
      <el-input
        placeholder="冠心病或支架植入史（单位：年）"
        v-model="form.coronaryHeartDiseaseYear"
        :disabled="form.coronaryHeartDisease == '否'"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="腹性肥胖">
      <el-radio-group v-model="form.bellyFat"
        :fill="form.bellyFat==''||form.bellyFat=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="眩晕">
      <el-radio-group v-model="form.dizziness"
        :fill="form.dizziness==''||form.dizziness=='从不'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="从不"></el-radio-button>
        <el-radio-button label="偶尔"></el-radio-button>
        <el-radio-button label="经常"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="胸闷胸痛肩背痛">
      <el-radio-group v-model="form.chestDistress"
        :fill="form.chestDistress==''||form.chestDistress=='从不'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="从不"></el-radio-button>
        <el-radio-button label="偶尔"></el-radio-button>
        <el-radio-button label="经常"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="神疲乏力">
      <el-radio-group v-model="form.fatigue"
        :fill="form.fatigue==''||form.fatigue=='从不'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="从不"></el-radio-button>
        <el-radio-button label="偶尔"></el-radio-button>
        <el-radio-button label="经常"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="心悸气短自汗">
      <el-radio-group v-model="form.sweat"
        :fill="form.sweat==''||form.sweat=='从不'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="从不"></el-radio-button>
        <el-radio-button label="偶尔"></el-radio-button>
        <el-radio-button label="经常"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="家族冠心病">
      <el-radio-group v-model="form.familyChd"
        :fill="form.familyChd==''||form.familyChd=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="家族心梗史">
      <el-radio-group v-model="form.familyMi"
        :fill="form.familyMi==''||form.familyMi=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="脂肪肝">
      <el-radio-group v-model="form.fattyLiver"
        :fill="form.fattyLiver==''||form.fattyLiver=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    
    <el-form-item label="您是否通过医院检查，明确知道患有某种疾病？">
      <el-radio-group
        v-model="form.confirmedDesease"
        @change="selectConfirmedDisease"
        :fill="form.confirmedDesease==''||form.confirmedDesease=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="疾病名称">
      <el-input
        placeholder="疾病名称"
        v-model="form.diseaseName"
        :disabled="form.confirmedDesease == '否'"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="您是否一直坚持服药或其他治疗方法治疗该病？">
      <el-radio-group
        v-model="form.longTimeDrug"
        @change="selectLongTimeDrug"
        :fill="form.longTimeDrug==''||form.longTimeDrug=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="治疗方法">
      <el-input
        placeholder="治疗方法"
        v-model="form.drugName"
        :disabled="form.longTimeDrug == '否'"
      >
      </el-input>
    </el-form-item>


    <el-form-item label="服药史">
      <el-radio-group v-model="form.medicineHistory"
        :fill="form.medicineHistory==''||form.medicineHistory=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="药物名称">
      <el-input
        placeholder="药物名称"
        v-model="form.medicineName"
        :disabled="form.medicineHistory==null || form.medicineHistory == '否'"
      >
      </el-input>
    </el-form-item>

    <el-form-item label="保健品/药膳">
      <el-radio-group v-model="form.healthProduct"
        :fill="form.healthProduct==''||form.healthProduct=='否'?'#409EFF':'#FF0000'"
        text-color="#FFFFFF"
      >
        <el-radio-button label="否"></el-radio-button>
        <el-radio-button label="是"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="保健品/药膳名称">
      <el-input
        placeholder="保健品/药膳名称"
        v-model="form.productName"
        :disabled="form.healthProduct == '否'"
      >
      </el-input>
    </el-form-item>
    <el-button v-show="!disabled" :loading="submitting" type="primary" @click="doUpdateUserMedHistory" size="medium" class="fullWidth">保存</el-button>
  </el-form>
  <!-- <div v-else>
    <el-alert
      title="系统发现您还未录入既往病史信息"
      description="请护士或医生在检查阶段，在病人自述中咨询病人后录入。"
      type="warning"
      show-icon
      :closable="false"
    ></el-alert>
  </div> -->
</template>

<script>

import { getUserMedHistory, updateUserMedHistory } from "../../api/userService";

export default {
  name:"MedicalHistory",
  props: {
    teleNum: String,
    disabled: Boolean,
  },
  data() {
    return {
      fill: "#123456",
      //按钮提交中
      submitting: false,
      // 是否已提交过
      registered:false,
      confirmedDiseaseInputDisabled: true,
      drugNameInputDisabled: true,
       //既往病史
      form: {
        bellyFat: "否",
        coronaryHeartDisease: "否",
        coronaryHeartDiseaseYear: "",
        diabetes: "否",
        diabetesYear: "",
        familyChd: "否",
        familyMi: "否",
        fattyLiver: "否",
        dizziness: "从不",
        chestDistress: "从不",
        fatigue: "从不",
        sweat: "从不",
        healthProduct: "否",
        productName:"",
        highBloodPressure: "否",
        highBloodPressureYear: "",
        confirmedDesease: "否",
        diseaseName: "",
        longTimeDrug: "否",
        drugName: "",
        medicineHistory:"否",
        medicineName:"",
        userMedHistoryTeleNum: this.teleNum,
      },
    };
  },
  methods: {
    //病史中选择了明确患有某种疾病
    selectConfirmedDisease(value) {
      if (value == "是") {
        this.confirmedDiseaseInputDisabled = false;
      } else {
        this.confirmedDisease = "";
        this.confirmedDiseaseInputDisabled = true;
      }
    },
    //病史中选择了明确患有某种疾病
    selectLongTimeDrug(value) {
      if (value == "是") {
        this.drugNameInputDisabled = false;
      } else {
        this.drugName = "";
        this.drugNameInputDisabled = true;
      }
    },
    //获取用户病史信息
    _getUserMedHistory() {
      //我的诊断中获取 既往病史
      getUserMedHistory( this.teleNum).then((res) => {
        //如果已有用户病史则加载数据库中的信息
        if (res.data[0]) {
          this.form = this.getConverter(res.data[0]);
          this.registered = true;
        }else{
          this.registered = false;
        }
      });
    },
    //更新用户病史信息
    doUpdateUserMedHistory() {
      this.submitting= true;
      let data = this.postConverter(this.form);
      updateUserMedHistory(JSON.stringify(data))
        .then((res) => {
          this.submitting= false;
          if (res.success) {
            this.$message({
              message: "更新用户既往病史成功",
              type: "success",
            });
            //更新客户既往病史信息
            this.form = this.getConverter(res.data[0].userMedHistory);
            //此接口暂时存在问题:TODO
            // this._getUserMedHistory()
          } else {
            //如果接口调用失败则 告知用户错误信息
            this.$message.error(res.description);
          }
        })
        .catch((e) => {
          this.submitting= false;
          console.log(e);
        });
    },
    // 病史 对象转换器
    getConverter(obj) {
      let data = {};
      for (let key in obj) {
        if (key == "highBloodPressure") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
            data[key] = "是";
            data["highBloodPressureYear"] = obj[key];
          } else {
            data[key] = "否";
            data["highBloodPressureYear"] = "";
          }
        } 
        else if (key == "coronaryHeartDisease") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
            data[key] = "是";
            data["coronaryHeartDiseaseYear"] = obj[key];
          } else {
            data[key] = "否";
            data["coronaryHeartDiseaseYear"] = "";
          }
        }
        else if (key == "diabetes") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
            data[key] = "是";
            data["diabetesYear"] = obj[key];
          } else {
            data[key] = "否";
            data["diabetesYear"] = "";
          }
        }
        else if (key == "longTimeDrug") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
             data[key] = "是";
            data["drugName"] = obj[key];
          } else {
            data[key] = "否";
            data["drugName"] = "";
          }
        } else if (key == "confirmedDesease") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
               data[key] = "是";
              data["diseaseName"] = obj[key];
            } else {
              data[key] = "否";
              data["diseaseName"] = "";
            }
        } else if (key == "medicineHistory") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
               data[key] = "是";
              data["medicineName"] = obj[key];
            } else {
              data[key] = "否";
              data["medicineName"] = "";
            }
        }
        else if (key == "healthProduct") {
          if (obj[key] != "" && obj[key]!="否" && obj[key]!=null) {
               data[key] = "是";
              data["productName"] = obj[key];
            } else {
              data[key] = "否";
              data["productName"] = "";
            }
        } else {
          data[key] = obj[key];
        }
      }
      return data;
    },
    postConverter(obj) {
      let data = {};
      for (let key in obj) {
        if (key == "highBloodPressure") {
          if (obj[key] == "是") data[key] = obj["highBloodPressureYear"];
          else data[key] = "否";
        } 
        else if (key == "coronaryHeartDisease") {
          if (obj[key] == "是") data[key] = obj["coronaryHeartDiseaseYear"];
          else data[key] = "否";
        } 
        else if (key == "diabetes") {
          if (obj[key] == "是") data[key] = obj["diabetesYear"];
          else data[key] = "否";
        } 
        else if (key == "longTimeDrug") {
          if (obj[key] == "是") data[key] = obj["drugName"];
          else data[key] = "否";
        } else if (key == "confirmedDesease") {
          if (obj[key] == "是") data[key] = obj["diseaseName"];
          else data[key] = "否";
        } else if (key == "medicineHistory") {
          if (obj[key] == "是") data[key] = obj["medicineName"];
          else data[key] = "否";
        } else if (key == "healthProduct") {
          if (obj[key] == "是") data[key] = obj["productName"];
          else data[key] = "否";
        } else {
          data[key] = obj[key];
        }
      }
      delete data.highBloodPressureYear;
      delete data.drugName;
      delete data.diseaseName;
      delete data.productName;
      return data;
    },
  },
  created() {
    this._getUserMedHistory();
  },
};
</script>

<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.highlight {
  color: red;
}

/* .pad {
  padding-left: 40px;
  padding-right: 40px;
} */
.fullWidth {
  width: 100%;
}
.fr {
  float: right;
}
</style>